export const homepage = {
    'meta': {
        'title': 'Psychiatra dziecięcy, Psychiatra, Psychoterapia, Psychologia | COLLIGO #cityLocativeIn#',
        'description': 'Psychiatra dziecięcy #cityLocativeInDefault#. Psychiatra #cityLocativeInDefault#. Psychoterapia #cityLocativeInDefault#. Psychologia #cityLocativeInDefault#. Gabinety w dogodnym miejscu #cityLocativeInDefault#.'
    },
    'url': {
        'address': '#cityIdUrl#/',
        'title': 'Psychiatra dziecięcy, Psychiatra, Psychoterapia, Psychologia | COLLIGO #cityLocativeIn#',
        'name': 'Strona główna'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dziecięcy #cityLocativeInDefault#. Psychiatra #cityLocativeInDefault#. Psychoterapia #cityLocativeInDefault#. Psychologia #cityLocativeInDefault#. Gabinety w dogodnym miejscu #cityLocativeInDefault#.'
        }
    }
}